//USER ACTIONS
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCEED = 'LOGIN_SUCCEED';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const GET_MY_PROFILE_REQUEST = 'GET_MY_PROFILE_REQUEST';
export const GET_MY_PROFILE_SUCCEED = 'GET_MY_PROFILE_SUCCEED';
export const GET_MY_PROFILE_FAILED = 'GET_MY_PROFILE_FAILED';
export const EDIT_PROFILE_REQUEST = 'EDIT_PROFILE_REQUEST';
export const EDIT_PROFILE_SUCCEED = 'EDIT_PROFILE_SUCCEED';
export const EDIT_PROFILE_FAILED = 'EDIT_PROFILE_FAILED';
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCEED = 'FORGOT_PASSWORD_SUCCEED';
export const FORGOT_PASSWORD_FAILED = 'FORGOT_PASSWORD_FAILED';
export const REMOVE_AUTH_ERROR = 'REMOVE_AUTH_ERROR';
export const SET_EMAIL_SENT_TO_FALSE = 'SET_EMAIL_SENT_TO_FALSE';
export const LOG_OUT = 'LOG_OUT';

//ADMINS
export const GET_ADMINS_REQUEST = 'GET_ADMINS_REQUEST';
export const GET_ADMINS_SUCCEED = 'GET_ADMINS_SUCCEED';
export const GET_ADMINS_FAILED = 'GET_ADMINS_FAILED';
export const GET_ADMIN_DETAILS_REQUEST = 'GET_ADMIN_DETAILS_REQUEST';
export const GET_ADMIN_DETAILS_SUCCEED = 'GET_ADMIN_DETAILS_SUCCEED';
export const GET_ADMIN_DETAILS_FAILED = 'GET_ADMIN_DETAILS_FAILED';
export const ADD_ADMIN_REQUEST = 'ADD_ADMIN_REQUEST';
export const ADD_ADMIN_SUCCEED = 'ADD_ADMIN_SUCCEED';
export const ADD_ADMIN_FAILED = 'ADD_ADMIN_FAILED';
export const EDIT_ADMIN_REQUEST = 'EDIT_ADMIN_REQUEST';
export const EDIT_ADMIN_SUCCEED = 'EDIT_ADMIN_SUCCEED';
export const EDIT_ADMIN_FAILED = 'EDIT_ADMIN_FAILED';
export const DELETE_ADMIN_REQUEST = 'DELETE_ADMIN_REQUEST';
export const DELETE_ADMIN_SUCCEED = 'DELETE_ADMIN_SUCCEED';
export const DELETE_ADMIN_FAILED = 'DELETE_ADMIN_FAILED';

//SUPERVISORS
export const GET_SUPERVISORS_REQUEST = 'GET_SUPERVISORS_REQUEST';
export const GET_SUPERVISORS_SUCCEED = 'GET_SUPERVISORS_SUCCEED';
export const GET_SUPERVISORS_FAILED = 'GET_SUPERVISORS_FAILED';
export const GET_SUPERVISOR_DETAILS_REQUEST = 'GET_SUPERVISOR_DETAILS_REQUEST';
export const GET_SUPERVISOR_DETAILS_SUCCEED = 'GET_SUPERVISOR_DETAILS_SUCCEED';
export const GET_SUPERVISOR_DETAILS_FAILED = 'GET_SUPERVISOR_DETAILS_FAILED';
export const ADD_SUPERVISOR_REQUEST = 'ADD_SUPERVISOR_REQUEST';
export const ADD_SUPERVISOR_SUCCEED = 'ADD_SUPERVISOR_SUCCEED';
export const ADD_SUPERVISOR_FAILED = 'ADD_SUPERVISOR_FAILED';
export const EDIT_SUPERVISOR_REQUEST = 'EDIT_SUPERVISOR_REQUEST';
export const EDIT_SUPERVISOR_SUCCEED = 'EDIT_SUPERVISOR_SUCCEED';
export const EDIT_SUPERVISOR_FAILED = 'EDIT_SUPERVISOR_FAILED';
export const DELETE_SUPERVISOR_REQUEST = 'DELETE_SUPERVISOR_REQUEST';
export const DELETE_SUPERVISOR_SUCCEED = 'DELETE_SUPERVISOR_SUCCEED';
export const DELETE_SUPERVISOR_FAILED = 'DELETE_SUPERVISOR_FAILED';

//BUILDINGS
export const GET_ALL_BUILDINGS_REQUEST = 'GET_ALL_BUILDINGS_REQUEST';
export const GET_ALL_BUILDINGS_SUCCEED = 'GET_ALL_BUILDINGS_SUCCEED';
export const GET_ALL_BUILDINGS_FAILED = 'GET_ALL_BUILDINGS_FAILED';
export const GET_BUILDINGS_REQUEST = 'GET_BUILDINGS_REQUEST';
export const GET_BUILDINGS_SUCCEED = 'GET_BUILDINGS_SUCCEED';
export const GET_BUILDINGS_FAILED = 'GET_BUILDINGS_FAILED';
export const GET_BUILDING_DETAILS_REQUEST = 'GET_BUILDING_DETAILS_REQUEST';
export const GET_BUILDING_DETAILS_SUCCEED = 'GET_BUILDING_DETAILS_SUCCEED';
export const GET_BUILDING_DETAILS_FAILED = 'GET_BUILDING_DETAILS_FAILED';
export const ADD_BUILDING_REQUEST = 'ADD_BUILDING_REQUEST';
export const ADD_BUILDING_SUCCEED = 'ADD_BUILDING_SUCCEED';
export const ADD_BUILDING_FAILED = 'ADD_BUILDING_FAILED';
export const EDIT_BUILDING_REQUEST = 'EDIT_BUILDING_REQUEST';
export const EDIT_BUILDING_SUCCEED = 'EDIT_BUILDING_SUCCEED';
export const EDIT_BUILDING_FAILED = 'EDIT_BUILDING_FAILED';
export const DELETE_BUILDING_REQUEST = 'DELETE_BUILDING_REQUEST';
export const DELETE_BUILDING_SUCCEED = 'DELETE_BUILDING_SUCCEED';
export const DELETE_BUILDING_FAILED = 'DELETE_BUILDING_FAILED';
export const GET_BUILDINGS_GRAPH_REQUEST = 'GET_BUILDINGS_GRAPH_REQUEST';
export const GET_BUILDINGS_GRAPH_SUCCEED = 'GET_BUILDINGS_GRAPH_SUCCEED';
export const GET_BUILDINGS_GRAPH_FAILED = 'GET_BUILDINGS_GRAPH_FAILED';

//ENTRANCES
export const GET_BUILDING_ENTRANCES_REQUEST = 'GET_BUILDING_ENTRANCES_REQUEST';
export const GET_BUILDING_ENTRANCES_SUCCEED = 'GET_BUILDING_ENTRANCES_SUCCEED';
export const GET_BUILDING_ENTRANCES_FAILED = 'GET_BUILDING_ENTRANCES_FAILED';
export const GET_ENTRANCES_REQUEST = 'GET_ENTRANCES_REQUEST';
export const GET_ENTRANCES_SUCCEED = 'GET_ENTRANCES_SUCCEED';
export const GET_ENTRANCES_FAILED = 'GET_ENTRANCES_FAILED';
export const GET_ENTRANCE_DETAILS_REQUEST = 'GET_ENTRANCE_DETAILS_REQUEST';
export const GET_ENTRANCE_DETAILS_SUCCEED = 'GET_ENTRANCE_DETAILS_SUCCEED';
export const GET_ENTRANCE_DETAILS_FAILED = 'GET_ENTRANCE_DETAILS_FAILED';
export const ADD_ENTRANCE_REQUEST = 'ADD_ENTRANCE_REQUEST';
export const ADD_ENTRANCE_SUCCEED = 'ADD_ENTRANCE_SUCCEED';
export const ADD_ENTRANCE_FAILED = 'ADD_ENTRANCE_FAILED';
export const EDIT_ENTRANCE_REQUEST = 'EDIT_ENTRANCE_REQUEST';
export const EDIT_ENTRANCE_SUCCEED = 'EDIT_ENTRANCE_SUCCEED';
export const EDIT_ENTRANCE_FAILED = 'EDIT_ENTRANCE_FAILED';
export const DELETE_ENTRANCE_REQUEST = 'DELETE_ENTRANCE_REQUEST';
export const DELETE_ENTRANCE_SUCCEED = 'DELETE_ENTRANCE_SUCCEED';
export const DELETE_ENTRANCE_FAILED = 'DELETE_ENTRANCE_FAILED';

//ELEVATORS
export const GET_ALL_ELEVATORS_REQUEST = 'GET_ALL_ELEVATORS_REQUEST';
export const GET_ALL_ELEVATORS_SUCCEED = 'GET_ALL_ELEVATORS_SUCCEED';
export const GET_ALL_ELEVATORS_FAILED = 'GET_ALL_ELEVATORS_FAILED';
export const GET_ELEVATORS_REQUEST = 'GET_ELEVATORS_REQUEST';
export const GET_ELEVATORS_SUCCEED = 'GET_ELEVATORS_SUCCEED';
export const GET_ELEVATORS_FAILED = 'GET_ELEVATORS_FAILED';
export const GET_INACTIVE_ELEVATORS_REQUEST = 'GET_INACTIVE_ELEVATORS_REQUEST';
export const GET_INACTIVE_ELEVATORS_SUCCEED = 'GET_INACTIVE_ELEVATORS_SUCCEED';
export const GET_INACTIVE_ELEVATORS_FAILED = 'GET_INACTIVE_ELEVATORS_FAILED';
export const GET_ELEVATOR_DETAILS_REQUEST = 'GET_ELEVATOR_DETAILS_REQUEST';
export const GET_ELEVATOR_DETAILS_SUCCEED = 'GET_ELEVATOR_DETAILS_SUCCEED';
export const GET_ELEVATOR_DETAILS_FAILED = 'GET_ELEVATOR_DETAILS_FAILED';
export const GET_BUILDING_ELEVATORS_REQUEST = 'GET_BUILDING_ELEVATORS_REQUEST';
export const GET_BUILDING_ELEVATORS_SUCCEED = 'GET_BUILDING_ELEVATORS_SUCCEED';
export const GET_BUILDING_ELEVATORS_FAILED = 'GET_BUILDING_ELEVATORS_FAILED';
export const GET_ENTRANCE_ELEVATORS_REQUEST = 'GET_ENTRANCE_ELEVATORS_REQUEST';
export const GET_ENTRANCE_ELEVATORS_SUCCEED = 'GET_ENTRANCE_ELEVATORS_SUCCEED';
export const GET_ENTRANCE_ELEVATORS_FAILED = 'GET_ENTRANCE_ELEVATORS_FAILED';
export const ADD_ELEVATOR_REQUEST = 'ADD_ELEVATOR_REQUEST';
export const ADD_ELEVATOR_SUCCEED = 'ADD_ELEVATOR_SUCCEED';
export const ADD_ELEVATOR_FAILED = 'ADD_ELEVATOR_FAILED';
export const EDIT_ELEVATOR_REQUEST = 'EDIT_ELEVATOR_REQUEST';
export const EDIT_ELEVATOR_SUCCEED = 'EDIT_ELEVATOR_SUCCEED';
export const EDIT_ELEVATOR_FAILED = 'EDIT_ELEVATOR_FAILED';
export const DELETE_ELEVATOR_REQUEST = 'DELETE_ELEVATOR_REQUEST';
export const DELETE_ELEVATOR_SUCCEED = 'DELETE_ELEVATOR_SUCCEED';
export const DELETE_ELEVATOR_FAILED = 'DELETE_ELEVATOR_FAILED';
export const GET_ELEVATOR_CONGIFURATIONS_REQUEST =
  'GET_ELEVATOR_CONGIFURATIONS_REQUEST';
export const GET_ELEVATOR_CONGIFURATIONS_SUCCEED =
  'GET_ELEVATOR_CONGIFURATIONS_SUCCEED';
export const GET_ELEVATOR_CONGIFURATIONS_FAILED =
  'GET_ELEVATOR_CONGIFURATIONS_FAILED';
export const CONFIGURE_ELEVATOR_REQUEST = 'CONFIGURE_ELEVATOR_REQUEST';
export const CONFIGURE_ELEVATOR_SUCCEED = 'CONFIGURE_ELEVATOR_SUCCEED';
export const CONFIGURE_ELEVATOR_FAILED = 'CONFIGURE_ELEVATOR_FAILED';

//CUSTOMERS
export const GET_CUSTOMERS_REQUEST = 'GET_CUSTOMERS_REQUEST';
export const GET_CUSTOMERS_SUCCEED = 'GET_CUSTOMERS_SUCCEED';
export const GET_CUSTOMERS_FAILED = 'GET_CUSTOMERS_FAILED';
export const GET_CUSTOMERS_BY_SITE_REQUEST = 'GET_CUSTOMERS_BY_SITE_REQUEST';
export const GET_CUSTOMERS_BY_SITE_SUCCEED = 'GET_CUSTOMERS_BY_SITE_SUCCEED';
export const GET_CUSTOMERS_BY_SITE_FAILED = 'GET_CUSTOMERS_BY_SITE_FAILED';
export const GET_CUSTOMERS_BY_CODE_REQUEST = 'GET_CUSTOMERS_BY_CODE_REQUEST';
export const GET_CUSTOMERS_BY_CODE_SUCCEED = 'GET_CUSTOMERS_BY_CODE_SUCCEED';
export const GET_CUSTOMERS_BY_CODE_FAILED = 'GET_CUSTOMERS_BY_CODE_FAILED';
export const GET_CUSTOMER_DETAILS_REQUEST = 'GET_CUSTOMER_DETAILS_REQUEST';
export const GET_CUSTOMER_DETAILS_SUCCEED = 'GET_CUSTOMER_DETAILS_SUCCEED';
export const GET_CUSTOMER_DETAILS_FAILED = 'GET_CUSTOMER_DETAILS_FAILED';
export const GET_BUILDING_CUSTOMERS_REQUEST = 'GET_BUILDING_CUSTOMERS_REQUEST';
export const GET_BUILDING_CUSTOMERS_SUCCEED = 'GET_BUILDING_CUSTOMERS_SUCCEED';
export const GET_BUILDING_CUSTOMERS_FAILED = 'GET_BUILDING_CUSTOMERS_FAILED';
export const GET_ENTRANCE_CUSTOMERS_REQUEST = 'GET_ENTRANCE_CUSTOMERS_REQUEST';
export const GET_ENTRANCE_CUSTOMERS_SUCCEED = 'GET_ENTRANCE_CUSTOMERS_SUCCEED';
export const GET_ENTRANCE_CUSTOMERS_FAILED = 'GET_ENTRANCE_CUSTOMERS_FAILED';
export const ADD_CUSTOMER_REQUEST = 'ADD_CUSTOMER_REQUEST';
export const ADD_CUSTOMER_SUCCEED = 'ADD_CUSTOMER_SUCCEED';
export const ADD_CUSTOMER_FAILED = 'ADD_CUSTOMER_FAILED';
export const EDIT_CUSTOMER_REQUEST = 'EDIT_CUSTOMER_REQUEST';
export const EDIT_CUSTOMER_SUCCEED = 'EDIT_CUSTOMER_SUCCEED';
export const EDIT_CUSTOMER_FAILED = 'EDIT_CUSTOMER_FAILED';
export const DELETE_CUSTOMER_REQUEST = 'DELETE_CUSTOMER_REQUEST';
export const DELETE_CUSTOMER_SUCCEED = 'DELETE_CUSTOMER_SUCCEED';
export const DELETE_CUSTOMER_FAILED = 'DELETE_CUSTOMER_FAILED';

//CARDS
export const GET_CUSTOMER_CARDS_REQUEST = 'GET_CUSTOMER_CARDS_REQUEST';
export const GET_CUSTOMER_CARDS_SUCCEED = 'GET_CUSTOMER_CARDS_SUCCEED';
export const GET_CUSTOMER_CARDS_FAILED = 'GET_CUSTOMER_CARDS_FAILED';
export const GET_ALL_CUSTOMER_CARDS_REQUEST = 'GET_ALL_CUSTOMER_CARDS_REQUEST';
export const GET_ALL_CUSTOMER_CARDS_SUCCEED = 'GET_ALL_CUSTOMER_CARDS_SUCCEED';
export const GET_ALL_CUSTOMER_CARDS_FAILED = 'GET_ALL_CUSTOMER_CARDS_FAILED';
export const GET_CARD_DETAILS_REQUEST = 'GET_CARD_DETAILS_REQUEST';
export const GET_CARD_DETAILS_SUCCEED = 'GET_CARD_DETAILS_SUCCEED';
export const GET_CARD_DETAILS_FAILED = 'GET_CARD_DETAILS_FAILED';
export const ADD_CARD_REQUEST = 'ADD_CARD_REQUEST';
export const ADD_CARD_SUCCEED = 'ADD_CARD_SUCCEED';
export const ADD_CARD_FAILED = 'ADD_CARD_FAILED';
export const EDIT_CARD_REQUEST = 'EDIT_CARD_REQUEST';
export const EDIT_CARD_SUCCEED = 'EDIT_CARD_SUCCEED';
export const EDIT_CARD_FAILED = 'EDIT_CARD_FAILED';
export const REACTIVATE_CARD_REQUEST = 'REACTIVATE_CARD_REQUEST';
export const REACTIVATE_CARD_SUCCEED = 'REACTIVATE_CARD_SUCCEED';
export const REACTIVATE_CARD_FAILED = 'REACTIVATE_CARD_FAILED';
export const DELETE_CARD_REQUEST = 'DELETE_CARD_REQUEST';
export const DELETE_CARD_SUCCEED = 'DELETE_CARD_SUCCEED';
export const DELETE_CARD_FAILED = 'DELETE_CARD_FAILED';
export const ACTIVATE_ALL_CARDS_REQUEST = 'ACTIVATE_ALL_CARDS_REQUEST';
export const ACTIVATE_ALL_CARDS_SUCCEED = 'ACTIVATE_ALL_CARDS_SUCCEED';
export const ACTIVATE_ALL_CARDS_FAILED = 'ACTIVATE_ALL_CARDS_FAILED';
export const DEACTIVATE_ALL_CARDS_REQUEST = 'DEACTIVATE_ALL_CARDS_REQUEST';
export const DEACTIVATE_ALL_CARDS_SUCCEED = 'DEACTIVATE_ALL_CARDS_SUCCEED';
export const DEACTIVATE_ALL_CARDS_FAILED = 'DEACTIVATE_ALL_CARDS_FAILED';
export const ASSIGN_CARDS_REQUEST = 'ASSIGN_CARDS_REQUEST';
export const ASSIGN_CARDS_SUCCEED = 'ASSIGN_CARDS_SUCCEED';
export const ASSIGN_CARDS_FAILED = 'ASSIGN_CARDS_FAILED';
export const GET_CARDS_BY_ELEVATOR_REQUEST = 'GET_CARDS_BY_ELEVATOR_REQUEST';
export const GET_CARDS_BY_ELEVATOR_SUCCEED = 'GET_CARDS_BY_ELEVATOR_SUCCEED';
export const GET_CARDS_BY_ELEVATOR_FAILED = 'GET_CARDS_BY_ELEVATOR_FAILED';
export const REMOVE_CARDS_BY_ELEVATOR = 'REMOVE_CARDS_BY_ELEVATOR';
export const GET_FREQUENTLY_USED_CARDS_REQUEST = 'GET_FREQUENTLY_USED_CARDS_REQUEST';
export const GET_FREQUENTLY_USED_CARDS_SUCCEED = 'GET_FREQUENTLY_USED_CARDS_SUCCEED';
export const GET_FREQUENTLY_USED_CARDS_FAILED = 'GET_FREQUENTLY_USED_CARDS_FAILED';

//PAYMENTS
export const GET_CUSTOMER_PAYMENTS_REQUEST = 'GET_CUSTOMER_PAYMENTS_REQUEST';
export const GET_CUSTOMER_PAYMENTS_SUCCEED = 'GET_CUSTOMER_PAYMENTS_SUCCEED';
export const GET_CUSTOMER_PAYMENTS_FAILED = 'GET_CUSTOMER_PAYMENTS_FAILED';
export const ADD_PAYMENT_REQUEST = 'ADD_PAYMENT_REQUEST';
export const ADD_PAYMENT_SUCCEED = 'ADD_PAYMENT_SUCCEED';
export const ADD_PAYMENT_FAILED = 'ADD_PAYMENT_FAILED';
export const GET_ALL_PAYMENTS_REQUEST = 'GET_ALL_PAYMENTS_REQUEST';
export const GET_ALL_PAYMENTS_SUCCEED = 'GET_ALL_PAYMENTS_SUCCEED';
export const GET_ALL_PAYMENTS_FAILED = 'GET_ALL_PAYMENTS_FAILED';
export const GET_TOTAL_PAYMENTS_REQUEST = 'GET_TOTAL_PAYMENTS_REQUEST';
export const GET_TOTAL_PAYMENTS_SUCCEED = 'GET_TOTAL_PAYMENTS_SUCCEED';
export const GET_TOTAL_PAYMENTS_FAILED = 'GET_TOTAL_PAYMENTS_FAILED';
export const GET_PAYMENTS_GRAPH_REQUEST = 'GET_PAYMENTS_GRAPH_REQUEST';
export const GET_PAYMENTS_GRAPH_SUCCEED = 'GET_PAYMENTS_GRAPH_SUCCEED';
export const GET_PAYMENTS_GRAPH_FAILED = 'GET_PAYMENTS_GRAPH_FAILED';
export const GET_PENDING_PAYMENTS_REQUEST = 'GET_PENDING_PAYMENTS_REQUEST';
export const GET_PENDING_PAYMENTS_SUCCEED = 'GET_PENDING_PAYMENTS_SUCCEED';
export const GET_PENDING_PAYMENTS_FAILED = 'GET_PENDING_PAYMENTS_FAILED';

//REPORTS
export const GET_LOGS_REQUEST = 'GET_LOGS_REQUEST';
export const GET_LOGS_SUCCEED = 'GET_LOGS_SUCCEED';
export const GET_LOGS_FAILED = 'GET_LOGS_FAILED';
export const GET_CHECKINS_REQUEST = 'GET_CHECKINS_REQUEST';
export const GET_CHECKINS_SUCCEED = 'GET_CHECKINS_SUCCEED';
export const GET_CHECKINS_FAILED = 'GET_CHECKINS_FAILED';
export const GET_CUSTOMERS_CHECKINS_REQUEST = 'GET_CUSTOMERS_CHECKINS_REQUEST';
export const GET_CUSTOMERS_CHECKINS_SUCCEED = 'GET_CUSTOMERS_CHECKINS_SUCCEED';
export const GET_CUSTOMERS_CHECKINS_FAILED = 'GET_CUSTOMERS_CHECKINS_FAILED';
export const GET_INVALID_STATUS_CARDS_REQUEST = 'GET_INVALID_STATUS_CARDS_REQUEST';
export const GET_INVALID_STATUS_CARDS_SUCCEED = 'GET_INVALID_STATUS_CARDS_SUCCEED';
export const GET_INVALID_STATUS_CARDS_FAILED = 'GET_INVALID_STATUS_CARDS_FAILED';

//PDF REPORTS
export const ADD_PDF_REPORT_REQUEST = 'ADD_PDF_REPORT_REQUEST';
export const ADD_PDF_REPORT_SUCCEED = 'ADD_PDF_REPORT_SUCCEED';
export const ADD_PDF_REPORT_FAILED = 'ADD_PDF_REPORT_REQUEST';
export const GET_PDF_REPORT_REQUEST = 'GET_PDF_REPORT_REQUEST';
export const GET_PDF_REPORT_SUCCEED = 'GET_PDF_REPORT_SUCCEED';
export const GET_PDF_REPORT_FAILED = 'GET_PDF_REPORT_FAILED';
export const GET_PDF_PAYLOAD_BY_ID_REQUEST = 'GET_PDF_PAYLOAD_BY_ID_REQUEST';
export const GET_PDF_PAYLOAD_BY_ID_SUCCEED = 'GET_PDF_PAYLOAD_BY_ID_SUCCEED';
export const GET_PDF_PAYLOAD_BY_ID_FAILED = 'GET_PDF_PAYLOAD_BY_ID_FAILED';
export const GET_PDF_REPORT_BY_NAME_REQUEST = 'GET_PDF_REPORT_BY_NAME_REQUEST';
export const GET_PDF_REPORT_BY_NAME_SUCCEED = 'GET_PDF_REPORT_BY_NAME_SUCCEED';
export const GET_PDF_REPORT_BY_NAME_FAILED = 'GET_PDF_REPORT_BY_NAME_FAILED';
export const SEND_PDF_REPORT_EMAIL_REQUEST = 'SEND_PDF_REPORT_EMAIL_REQUEST';
export const SEND_PDF_REPORT_EMAIL_SUCCEED = 'SEND_PDF_REPORT_EMAIL_SUCCEED';
export const SEND_PDF_REPORT_EMAIL_FAILED = 'SEND_PDF_REPORT_EMAIL_FAILED';

//MODALS
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

//TOASTS
export const SHOW_TOAST = 'SHOW_TOAST';
export const HIDE_TOAST = 'HIDE_TOAST';

//NOTES
export const ADD_NOTE_REQUEST = 'ADD_NOTE_REQUEST';
export const ADD_NOTE_SUCCEED = 'ADD_NOTE_SUCCEED';
export const ADD_NOTE_FAILED = 'ADD_NOTE_FAILED';
export const GET_NOTES_REQUEST = 'GET_NOTES_REQUEST';
export const GET_NOTES_SUCCEED = 'GET_NOTES_SUCCEED';
export const GET_NOTES_FAILED = 'GET_NOTES_FAILED';

//GARAGES
export const GET_BUILDING_GARAGES_REQUEST = 'GET_BUILDING_GARAGES_REQUEST';
export const GET_BUILDING_GARAGES_SUCCEED = 'GET_BUILDING_GARAGES_SUCCEED';
export const GET_BUILDING_GARAGES_FAILED = 'GET_BUILDING_GARAGES_FAILED';
export const ADD_GARAGE_REQUEST = 'ADD_GARAGE_REQUEST';
export const ADD_GARAGE_SUCCEED = 'ADD_GARAGE_SUCCEED';
export const ADD_GARAGE_FAILED = 'ADD_GARAGE_FAILED';
export const EDIT_GARAGE_REQUEST = 'EDIT_GARAGE_REQUEST';
export const EDIT_GARAGE_SUCCEED = 'EDIT_GARAGE_SUCCEED';
export const EDIT_GARAGE_FAILED = 'EDIT_GARAGE_FAILED';
export const DELETE_GARAGE_REQUEST = 'DELETE_GARAGE_REQUEST';
export const DELETE_GARAGE_SUCCEED = 'DELETE_GARAGE_SUCCEED';
export const DELETE_GARAGE_FAILED = 'DELETE_GARAGE_FAILED';

//CUSTOMER GARAGES
export const GET_CUSTOMER_GARAGES_REQUEST = 'GET_CUSTOMER_GARAGES_REQUEST';
export const GET_CUSTOMER_GARAGES_SUCCEED = 'GET_CUSTOMER_GARAGES_SUCCEED';
export const GET_CUSTOMER_GARAGES_FAILED = 'GET_CUSTOMER_GARAGES_FAILED';
export const ADD_CUSTOMER_GARAGE_REQUEST = 'ADD_CUSTOMER_GARAGE_REQUEST';
export const ADD_CUSTOMER_GARAGE_SUCCEED = 'ADD_CUSTOMER_GARAGE_SUCCEED';
export const ADD_CUSTOMER_GARAGE_FAILED = 'ADD_CUSTOMER_GARAGE_FAILED';
export const EDIT_CUSTOMER_GARAGE_REQUEST = 'EDIT_CUSTOMER_GARAGE_REQUEST';
export const EDIT_CUSTOMER_GARAGE_SUCCEED = 'EDIT_CUSTOMER_GARAGE_SUCCEED';
export const EDIT_CUSTOMER_GARAGE_FAILED = 'EDIT_CUSTOMER_GARAGE_FAILED';
export const DELETE_CUSTOMER_GARAGE_REQUEST = 'DELETE_CUSTOMER_GARAGE_REQUEST';
export const DELETE_CUSTOMER_GARAGE_SUCCEED = 'DELETE_CUSTOMER_GARAGE_SUCCEED';
export const DELETE_CUSTOMER_GARAGE_FAILED = 'DELETE_CUSTOMER_GARAGE_FAILED';

//GARAGE REPORT
export const GET_GARAGE_REPORT_REQUEST = 'GET_GARAGE_REPORT_REQUEST';
export const GET_GARAGE_REPORT_SUCCEED = 'GET_GARAGE_REPORT_SUCCEED';
export const GET_GARAGE_REPORT_FAILED = 'GET_GARAGE_REPORT_FAILED';
export const GET_GARAGE_REPORT_FILTERS_REQUEST = 'GET_GARAGE_REPORT_FILTERS_REQUEST';
export const GET_GARAGE_REPORT_FILTERS_SUCCEED = 'GET_GARAGE_REPORT_FILTERS_SUCCEED';
export const GET_GARAGE_REPORT_FILTERS_FAILED = 'GET_GARAGE_REPORT_FILTERS_FAILED';
